<template>
  <StCompanySelection
    :companies="companies"
    :page-title="$t('StCompanySelection.pageTitle')"
    @selected="updateCompany"
  />
</template>

<script>
import StCompanySelection from '@stilingue/st-company-selection';
import { insertMixpanelPlugin } from '@/plugins/mixpanel';
import { insertPluginMetadata } from '@/plugins/insert_plugins_metadata';

export default {
  name: 'CompanySelection',
  components: {
    StCompanySelection,
  },
  data() {
    return {
      beforeRoute: '',
    };
  },
  computed: {
    companies() {
      return this.$store.state.company.companies;
    },
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.beforeRoute = from;
    });
  },
  async mounted() {
    await this.$store.dispatch('company/getCompanies');
  },
  methods: {
    configurePlugins(company) {
      insertMixpanelPlugin(
        this.$store.state.user.user,
        company.name
      );

      insertPluginMetadata({
        user: this.$store.state.user.user,
        activeCompany: company,
      });
    },
    async updateCompany(company) {
      this.$store.dispatch('company/addActiveCompany', company);
      this.configurePlugins(company);

      if (this.beforeRoute.path.includes('setup')) {
        return this.$router.push({
          name: this.beforeRoute.name,
        }).catch(() => null);
      }

      await this.$store.dispatch('benchmarks/startBenchmarks', {
        activeCompany: company,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.organizations-view {
  background-color: var(--gray-050);
}

.company-container__logo {
  margin: -50% auto 20px;
}

.company-container__card * {
  background-color: var(--ds-color-night);
}

.company-container__card__list {
  padding-top: 0;
  width: 100%;
}

::v-deep {
  .company-container__card__list-item {
    border-radius: 3px;
    width: 100%;
    height: 51px;
    margin-bottom: 5px;
    transition: none;

    .v-list__tile--link {
      transition: none !important;
    }

    &:hover,
    &:hover * {
      background-color: var(--gray-050) !important;
    }
  }
}
</style>
